import styled from 'styled-components/macro';
import { rgba } from 'polished';
import { COLORS } from 'styleguide';

const AuditRowWrapper = styled.div`
  margin: 16px 32px 24px 24px;
  color: ${rgba('#fff', 0.6)};
  border: 1px solid ${COLORS.line};
  border-radius: 4px;
`;

export default AuditRowWrapper;
